<script setup lang="ts">
import NavbarLogo from '@/components/navbar/NavbarLogo.vue'
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import SidebarMainMenu from '@/components/sidebar/SidebarMainMenu.vue'
import type { SidebarMenuButton } from '@/types'
import SidebarMainMenuUser from '@/components/sidebar/SidebarMainMenuUser.vue'
import InfoStock from '@/components/info/InfoStock.vue'
import InfoSale from '@/components/info/InfoSale.vue'

const appStore = useAppStore()
const show = computed(() => appStore.showSidebar)

const sidebarData: SidebarMenuButton[] = [
  {
    name: 'Home',
    icon: 'squares-four',
    url: 'home',
  },
  {
    name: 'Stock',
    icon: 'stack',
    url: 'stock',
    component: InfoStock,
  },
  {
    name: 'Sale (Transaction)',
    icon: 'shopping-cart',
    url: 'sale',
    component: InfoSale,
  },
  {
    name: 'Task / To-do List',
    icon: 'check-square-offset',
    url: 'task',
  },
]

const sidebarDataPart: SidebarMenuButton[] = [
  {
    name: 'Sparepart',
    icon: 'barcode',
    url: 'part',
  },
  // {
  //   name: 'Part for Sale',
  //   icon: 'seal-percent',
  //   url: 'part-sale',
  // },
  {
    name: 'Part Moving',
    icon: 'arrows-down-up',
    url: 'part-moving',
  },
]

const sidebarDataAccount: SidebarMenuButton[] = [
  {
    name: 'Account',
    icon: 'credit-card',
    url: 'account',
  },
  {
    name: 'Bank Account',
    icon: 'bank',
    url: 'account-bank',
  },
  {
    name: 'Transaction',
    icon: 'hand-coins',
    url: 'account-item',
  },
  {
    name: 'Category',
    icon: 'tag',
    url: 'account-item-category',
  },
]

const sidebarDataMisc: SidebarMenuButton[] = [
  {
    name: 'Config',
    icon: 'gear',
    url: 'config',
  },
  {
    name: 'Marketplace',
    icon: 'storefront',
    url: 'marketplace',
  },
  {
    name: 'Supplier',
    icon: 'truck',
    url: 'supplier',
  },
  {
    name: 'Delivery',
    icon: 'package',
    url: 'delivery',
  },
  {
    name: 'Bill',
    icon: 'receipt',
    url: 'bill',
  },
  {
    name: 'Invoice',
    icon: 'invoice',
    url: 'invoice',
  },
  {
    name: 'Customer',
    icon: 'users',
    url: 'customer',
  },
]
</script>

<template>
  <div
    :class="show ? 'w-70 min-w-70 px-2' : 'w-0 min-w-0 px-0 overflow-hidden'"
    class="pt-4 bg-stone-50 dark:bg-stone-800 shadow-xl transition-all duration-150"
  >
    <div class="flex flex-col">
      <navbar-logo class="mx-auto mb-6"></navbar-logo>

      <div class="flex flex-col space-y-6">
        <div>
          <sidebar-main-menu :data="sidebarData" title="main menu"></sidebar-main-menu>
        </div>

        <div>
          <sidebar-main-menu :data="sidebarDataPart" title="part manage"></sidebar-main-menu>
        </div>

        <div>
          <sidebar-main-menu :data="sidebarDataAccount" title="account manage"></sidebar-main-menu>
        </div>

        <div>
          <sidebar-main-menu :data="sidebarDataMisc" title="misc"></sidebar-main-menu>
        </div>
      </div>
    </div>

    <div class="sticky bottom-0 bg-stone-50 dark:bg-stone-800 transition-colors duration-150">
      <sidebar-main-menu-user></sidebar-main-menu-user>
    </div>
  </div>
</template>

<style scoped></style>
